import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';

import { FormField } from '../formField';
import styles from './ManualAddress.module.css';
import { supportsAutoAddress } from '../../helpers/address';
import { getCountry } from '../../iwIntlProvider/CountryProvider';

export function ManualAddress({ addressIndex = 0, onManualAddressToggle }) {
    return (
        <div data-testid="manual-address" className={styles.ManualAddress}>
            <div className={styles.twoColumnWrapper}>
                <FormField
                    data-testid="house-number-input"
                    className={classNames(
                        styles.houseNumberField,
                        'fs-exclude'
                    )}
                    name={`addresses[${addressIndex}].house_number`}
                    label={
                        <FormattedMessage
                            id="_.manual_address.house_number"
                            defaultMessage="House number"
                        />
                    }
                />

                <BuildingDetails addressIndex={addressIndex} />
            </div>

            <FormField
                data-testid="street-line-one-input"
                name={`addresses[${addressIndex}].street_line_1`}
                label={
                    <FormattedMessage
                        id="_.manual_address.street_line_1"
                        defaultMessage="Street line 1"
                    />
                }
                className="fs-exclude"
            />

            <FormField
                name={`addresses[${addressIndex}].street_line_2`}
                label={
                    <FormattedMessage
                        id="_.manual_address.street_line_2"
                        defaultMessage="Street line 2"
                    />
                }
                className="fs-exclude"
            />

            <div className={styles.twoColumnWrapper}>
                <FormField
                    data-testid="town-input"
                    name={`addresses[${addressIndex}].town`}
                    label={
                        <FormattedMessage
                            id="_.manual_address.town"
                            defaultMessage="Town"
                        />
                    }
                    className="fs-exclude"
                />
                <FormField
                    data-testid="post-code-input"
                    className={classNames(styles.postcodeField, 'fs-exclude')}
                    name={`addresses[${addressIndex}].postcode`}
                    label={
                        <FormattedMessage
                            id="_.manual_address.postcode"
                            defaultMessage="Postcode"
                        />
                    }
                />
            </div>

            {supportsAutoAddress() ? (
                <div
                    className={styles.manualAddressToggle}
                    onClick={() => onManualAddressToggle(addressIndex)}
                >
                    <FormattedMessage
                        id="_.manual_address.search_for_my_address"
                        defaultMessage="Search for my address"
                    />
                </div>
            ) : null}
        </div>
    );
}

function BuildingDetails({ addressIndex }) {
    switch (getCountry()) {
        case 'UK':
            return (
                <FormField
                    className={classNames(styles.houseNameField, 'fs-exclude')}
                    name={`addresses[${addressIndex}].house_name`}
                    label={
                        <FormattedMessage
                            id="_.manual_address.house_name"
                            defaultMessage="House name"
                        />
                    }
                />
            );
        case 'DE':
        default:
            return null;
    }
}
